import { render, staticRenderFns } from "./PneumoniaIndexAndPrevalenceAnalysisTable.vue?vue&type=template&id=26724a0e&scoped=true&"
import script from "./PneumoniaIndexAndPrevalenceAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./PneumoniaIndexAndPrevalenceAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./PneumoniaIndexAndPrevalenceAnalysisTable.vue?vue&type=style&index=0&id=26724a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26724a0e",
  null
  
)

export default component.exports